module.exports = __webpack_public_path__ + "img/upload-pdf.e41f765c.png";